import { useTranslation } from 'react-i18next';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';
import { Stack, Typography } from '@packages/fenrir/components';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

import { AssetInformationFieldWrapper } from './asset-information-field-wrapper/asset-information-field-wrapper';

interface AssetInformationOsProps {
  assetId: string;
}

export const AssetInformationOs = ({ assetId }: AssetInformationOsProps) => {
  const { t } = useTranslation('ads', {
    keyPrefix: 'assetDetails.information',
  });
  const [fullMockedFF] = useFeatureFlag('ADS_FULL_MOCKED');

  const { data: device } = useDeviceDetails(assetId);
  const { os } = device ?? {};

  return (
    <AssetInformationFieldWrapper
      assetId={assetId}
      term={t('os')}
      skeletonProps={{ width: '6rem' }}
    >
      {os ? (
        <Stack>
          <Typography variant="body2">{`${t('osDetails.name')} ${os.name}`}</Typography>
          {fullMockedFF && (
            <Typography variant="body2">{`${t('osDetails.vendor')} ${os.type}`}</Typography>
          )}
          <Typography variant="body2">{`${t('osDetails.version')} ${os.version}`}</Typography>
        </Stack>
      ) : undefined}
    </AssetInformationFieldWrapper>
  );
};
